// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__QOJ1z","Logo":"Loading_Logo__sGoyC","spin":"Loading_spin__+zS-D"};